/**
 * Main chart constants
 */
export const CHART = {
  FOOTER_HEIGHT: 20,
  PADDING: 12,
  LOADING_OPACITY: 0.15,
  PERIODS: ['7D', '3M', '1Y', 'MAX'],
  DEFAULT_SELECTED_PERIOD: '1Y',
  TOOLTIP_DATE_FORMAT: 'eee, d MMM yy',
} as const;

/**
 * Chart colors
 */
export const CHART_COLORS = {
  VALUATION: 'var(--s-color-chart-03)',
  DOWNTICK: 'var(--s-color-bad)',
  UPTICK: 'var(--s-color-good)',
} as const;

/**
 * CSS custom property names for consistent theming
 */
export const CSS_VARIABLES = {
  PRICE_COLOR: '--chart-price-color',
  VALUATION_COLOR: '--chart-valuation-color',
  POINT_STROKE: '--chart-point-stroke',
  HEIGHT: '--chart-height',
  PADDING: '--chart-padding',
} as const;
